import { render, staticRenderFns } from "./NameIcon.vue?vue&type=template&id=27a13be0&scoped=true&"
import script from "./NameIcon.vue?vue&type=script&lang=js&"
export * from "./NameIcon.vue?vue&type=script&lang=js&"
import style0 from "./NameIcon.vue?vue&type=style&index=0&id=27a13be0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a13be0",
  null
  
)

export default component.exports